import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import type { Flag } from "../../hooks/useFeatureFlags.types";

interface FeatureFlagProps {
  featureFlag: Flag;
  children: React.ReactNode;
}

function FeatureFlag({ children, featureFlag }: FeatureFlagProps) {
  const { featureFlags } = useFeatureFlags();
  const isActive = featureFlags[featureFlag];

  if (!isActive) {
    return null;
  }

  return <>{children}</>;
}

export { FeatureFlag, FeatureFlagProps };
